import { defineTheme } from '../contracts.js';
export const christmas = defineTheme({
    id: 'christmas',
    displayName: 'Christmas',
    lifecycle: 'development',
    selectable: false,
    implementation: 'native',
    capabilities: {
        alerts: 'reserved',
        welcomes: 'reserved',
        wam: 'reserved',
        startup: 'reserved',
        achievements: 'reserved',
        viewerSounds: 'reserved',
        privateChatSounds: 'reserved',
    },
});
//# sourceMappingURL=registration.js.map